<template>
  <b-row align-v="center">
    <b-col
      cols="12"
      lg="6"
    >
      <b-checkbox v-model="selected">
        <font-awesome-icon
          v-if="selected"
          icon="grip-vertical"
          size="sm"
          :class="{'drag-handle': selected }"
        /><span :class="{'drag-handle': selected }"> {{ name }}</span>
      </b-checkbox>
    </b-col>

    <b-col
      v-if="selected"
      cols="12"
      lg="6"
    >
      <ColorPicker v-model="color" />
    </b-col>
  </b-row>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import { ColorPicker } from '@orbica/vue-modules'

const components = {
  ColorPicker,
}
const props = {
  item: {
    type: Object,
    default: () => ({ column: 'column' }),
  },
  index: {
    type: Number,
    default: 0,
  },
}

@Component({ components })
export default class PieItem extends Vue.extend({ props }) {
  colorIndex = 0

  get piechartItems () {
    return this.$typedStore.visualisationApp.piechartItems
  }

  get selected () {
    // Check whether this item is in the array of piechartItems
    return this.piechartItems.some((item) => {
      return item.column === this.item.column
    })
  }

  set selected (newValue) {
    if (newValue) {
      this.$typedStore.visualisationApp.addPiechartItem(this.item.column)
    } else {
      this.$typedStore.visualisationApp.removePiechartItem(this.item.column)
    }

    // Toggle the graph to re-draw the d3 graph
    this.$emit('toggleGraph')
  }

  get name () {
    return this.$typedStore.visualisationApp.name(this.item.column)
  }

  get color () {
    return this.piechartItems
      .find((item) => {
        return item.column === this.item.column
      })?.color
  }

  set color (newValue) {
    // Need to clone the array to avoid issues with Vuex strict
    const index = this.piechartItems
      .findIndex((item) => {
        return item.column === this.item.column
      })
    this.$typedStore.primary.app.updateConfig({
      configPath: ['piechartItems', index, 'color'],
      value: newValue,
    })

    // Toggle the graph to re-draw the d3 graph
    this.$emit('toggleGraph')
  }
}
</script>

<style>

.drag-handle {
  cursor: move;
}

</style>
